




































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() originData!: any;
  dialogVisible: boolean = false;
  data: any = {
    agree: false,
  };
  @Watch("dialogVisible")
  onChangeValue() {
    // console.log("最新数据", this.originData);
    this.originData.viewList.forEach((item: any) => {
      if (item.preset_form_id > 5) {
        item.default_value = item.default_value
          ? JSON.stringify(
              JSON.parse(item.default_value).map((it: any) => {
                if (typeof it !== "object") {
                  return {
                    label: it,
                  };
                } else {
                  return {
                    label: it.label,
                  };
                }
              })
            )
          : "";
      }
    });
  }
  showDialog() {
    this.dialogVisible = true;
  }
}
